import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class AboutPage extends Component {
    render() {
        return(
            <section id="aboutus">
                <div className="container">
                                <div className="row align-items-center h-100">
                                    <div id="homescreen" className="col-xs-12 col-lg-12 mx-auto">
                                        <div id="logo">
                                            <Link to="/"><img src="img/grubrun-logo-ml.png" width="500" alt="Grub Run logo art" /></Link>
                                        </div>
                    <p className="aboutusp"><em>We're to blame, for always choosing the right place.</em></p>
                                    </div>
                                </div>    

                    <div className="section-title">
                        <h2><span>Why</span> We Exist?</h2>
                    </div>

                    <p className="white text-center">
                        GrubRun has saturated merely as an idea every since I was able to really witness couples. 
                        As kids my parents would always bicker about where to go eat. Where are we going? You pick! No, you pick! I don't really care! 
                        Then it usually ended with one of them blaming the other for not liking the food etc. 
                        For some reason I adopted the same conflict in my relationships, from friends, to girlfriends, to teamates etc. 
                        There in lies GrubRun. With our product you are able to save time, try new places, and enjoy your food! 
                        This not only helps our users, but also the food industry as a whole. With our product we are able to broaden the scope of restaurants 
                        communities engage in and adequetly provide information varied by prices and tastes such as described by 
                        <a href="http://www.economywatch.com/world-industries/food-industry.html"> Economy Watch.</a>
                    </p>

                    <div className="section-title">
                        <h2><span>What</span> Do We Do?</h2>
                    </div>
                    
                    <p className="white text-center">
                        GrubRun is made to learn & choose what best will suite your appetite at that time. Instead of looking at one another for the answer, you look at GrubRun. 
                        Now you can access GrubRun, enter your filters if desired, and let the app pick the place for you. Then follow the directions to restuarant and enjoy! 
                        Leave a review, and tell us if you liked it or didn't so we can learn more about your tastes! Our product reaches an industry that will always be present, 
                        because it is pivitol to survival, food. Everyone wants food and with people becoming increasingly busy and aiming for high quality meals, 
                        making the decision of where to go is hard! Let us make the right decision, and if you still want to have some control we give you that option. 
                        Add some filters and we'll work with what you set. We will pick the right place!
                    </p>
                </div>
            </section>
        );
    }
}

export default AboutPage;